// API endpoints
// All paths are relative, working for both dev and production:
// - Dev: Vite proxy forwards /api/* to http://localhost:8787
// - Production: Frontend served from same Worker that handles API
export const API_ENDPOINTS = {
  // Templates - baseToken in path
  getTemplates: (baseToken: string, tableId: string): string => `/api/bases/${baseToken}/tables/${tableId}/templates`,
  createTemplate: (baseToken: string, tableId: string): string => `/api/bases/${baseToken}/tables/${tableId}/templates`,
  updateTemplate: (baseToken: string, tableId: string, templateId: string): string => `/api/bases/${baseToken}/tables/${tableId}/templates/${templateId}`,
  deleteTemplate: (baseToken: string, tableId: string, templateId: string): string => `/api/bases/${baseToken}/tables/${tableId}/templates/${templateId}`,
  uploadTemplate: (baseToken: string, tableId: string, templateId: string): string => `/api/bases/${baseToken}/tables/${tableId}/templates/${templateId}/upload`,
  downloadTemplate: (baseToken: string, tableId: string, templateId: string): string => `/api/bases/${baseToken}/tables/${tableId}/templates/${templateId}/download`,
  generate: (baseToken: string, tableId: string, templateId: string): string => `/api/bases/${baseToken}/tables/${tableId}/templates/${templateId}/generate`,
  getGenerations: (baseToken: string, tableId: string): string => `/api/bases/${baseToken}/tables/${tableId}/generations`,
  downloadGeneration: (generationId: string): string => `/api/generations/${generationId}/download`,

  // Tenant endpoints (includes current base)
  getTenantInfo: (): string => `/api/tenant`,
  updateTenantInfo: (): string => `/api/tenant`,
  getTenantTemplates: (): string => `/api/tenant/templates`,

  // Admin endpoints
  adminListTenants: (): string => `/api/admin/tenants`,
  adminGetTenant: (tenantKey: string): string => `/api/admin/tenants/${tenantKey}`,
  adminUpdateTenant: (tenantKey: string): string => `/api/admin/tenants/${tenantKey}`,
  adminGenerateWebhookApiKey: (tenantKey: string): string => `/api/admin/tenants/${tenantKey}/webhook-api-key`,
  adminGetTenantBases: (tenantKey: string): string => `/api/admin/tenants/${tenantKey}/bases`,
  adminGetTenantUsers: (tenantKey: string): string => `/api/admin/tenants/${tenantKey}/users`,
  adminGetTenantTables: (tenantKey: string): string => `/api/admin/tenants/${tenantKey}/tables`,
  adminGetTenantGenerations: (tenantKey: string): string => `/api/admin/tenants/${tenantKey}/generations`,
  adminGetTenantTemplates: (tenantKey: string): string => `/api/admin/tenants/${tenantKey}/templates`,
  adminDownloadTemplate: (templateId: string): string => `/api/admin/templates/${templateId}/download`,
  adminDownloadGeneration: (generationId: string): string => `/api/admin/generations/${generationId}/download`,

  // Admin CRON endpoints
  adminTriggerQuotaUpdate: (): string => `/api/admin/cron/update-quotas`,
  adminTriggerCleanup: (): string => `/api/admin/cron/cleanup`,

  // Admin Worker endpoints
  adminGetWorkerStatus: (): string => `/api/admin/worker/status`,
}
